export interface Workbook {
  number: string;
  title: string;
  subtitle: string;
  description: string;
  tag: string;
  coverImage: string;
}

export const workbooks: Workbook[] = [
  {
    number: '01',
    title: 'MATERIA E TRASFORMAZIONI',
    subtitle: 'Proprietà, stati, miscele, soluzioni e trasformazioni della materia',
    description:
      'Un volume visuale e pronto per la classe dedicato alle proprietà della materia, agli stati di aggregazione, ai modelli particellari, alle sostanze pure, alle miscele, alle soluzioni e alle trasformazioni fisiche e chimiche. Aiuta gli studenti a passare dall’osservazione macroscopica all’interpretazione particellare e simbolica dei fenomeni.',
    tag: '60 pagine · Schede teoriche · Attività · Laboratori · Verifiche A/B · Soluzioni',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/r9E8kv3tYh3N78z3amtRiH/13f80f93-bb10-4839-9870-8d45a3e711db.webp',
  },
  {
    number: '02',
    title: 'STRUTTURA ATOMICA E PERIODICITÀ',
    subtitle: 'Atomi, isotopi, configurazione elettronica e proprietà periodiche',
    description:
      'Costruisce una comprensione progressiva della struttura atomica, degli isotopi, degli ioni, della configurazione elettronica, degli elettroni di valenza e dell’organizzazione della tavola periodica. Include attività visuali e guidate per interpretare le proprietà periodiche senza ridurle a definizioni da memorizzare.',
    tag: '60 pagine · Schede teoriche · Attività · Laboratori · Verifiche A/B · Soluzioni',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/bYJaCbpRnUMhiZschZSF55/b228096e-aaf4-4464-b1e5-ce1c74da0ed7.webp',
  },
  {
    number: '03',
    title: 'LEGAMI CHIMICI E STRUTTURA MOLECOLARE',
    subtitle: 'Strutture di Lewis, geometria, polarità e forze intermolecolari',
    description:
      'Accompagna gli studenti dalla configurazione elettronica alla comprensione dei legami ionici, covalenti e metallici. Comprende strutture di Lewis, carica formale, risonanza, teoria VSEPR, geometria molecolare, polarità e forze intermolecolari.',
    tag: '60 pagine · Schede teoriche · Attività · Laboratori · Verifiche A/B · Soluzioni',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/wZu7ZCFrAXRujqr6gqDXgL/ChatGPT-Image-6-ago-2026_-09_03_27-p.m..webp',
  },
  {
    number: '04',
    title: 'REAZIONI CHIMICHE E STECHIOMETRIA',
    subtitle: 'Nomenclatura, equazioni, mole, calcoli ed energia delle trasformazioni',
    description:
      'Un percorso completo che collega formule, nomenclatura, equazioni chimiche e descrizione quantitativa delle trasformazioni. Comprende bilanciamento, mole, massa molare, rapporti stechiometrici, reagente limitante, resa, purezza, soluzioni, gas, energia, velocità di reazione ed equilibrio chimico.',
    tag: '60 pagine · Schede teoriche · Attività · Laboratori · Verifiche A/B · Soluzioni',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/uAZe1ZqV161ac5hrcPSQhW/ChatGPT-Image-6-ago-2026_-09_03_21-p.m..webp',
  },
  {
    number: '05',
    title: 'CHIMICA ORGANICA E BIOSISTEMI',
    subtitle: 'Carbonio, gruppi funzionali, polimeri, biomolecole e sostenibilità',
    description:
      'Introduce la chimica del carbonio attraverso strutture, nomenclatura, isomeria, proprietà e trasformazioni fondamentali. Comprende idrocarburi, gruppi funzionali, polimeri, carboidrati, lipidi, proteine, acidi nucleici, enzimi, chimica ambientale e criteri di chimica verde.',
    tag: '60 pagine · Schede teoriche · Attività · Laboratori · Verifiche A/B · Soluzioni',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/r6YZhjQympgw4eUkFsN31H/ChatGPT-Image-6-ago-2026_-09_03_15-p.m..webp',
  },
];

export interface Bonus {
  badge: string;
  icon: string;
  title: string;
  subtitle: string;
  description: string;
  pages: string;
  value: string;
}

export const bonuses: Bonus[] = [
  {
    badge: 'BONUS 1',
    icon: '🎲',
    title: 'CHIMICA IN GIOCO™',
    subtitle: 'Carte, giochi, sfide ed escape room per il ripasso',
    description:
      'Una raccolta di giochi didattici completi, pronti da stampare, ritagliare e utilizzare. Comprende domino chimico, bingo degli elementi, memory, giochi “Chi sono?”, vero o falso, sfide di classificazione, carte della nomenclatura, corsa al bilanciamento, missioni di stechiometria, duello del pH e mini escape room.',
    pages: '48 pagine',
    value: '47 USD',
  },
  {
    badge: 'BONUS 2',
    icon: '🔬',
    title: 'CHIMICA IN AZIONE™',
    subtitle: 'Progetti scientifici visuali pronti per la classe',
    description:
      'Dieci progetti completi che trasformano i concetti teorici in domande investigabili, misure, dati e conclusioni. Ogni progetto comprende domanda di ricerca, ipotesi, variabili, materiali, sicurezza, procedimento, tabelle, grafici, analisi, conclusione e comunicazione finale.',
    pages: '48 pagine',
    value: '47 USD',
  },
  {
    badge: 'BONUS 3',
    icon: '📋',
    title: 'VALUTAZIONE FORMATIVA™',
    subtitle: 'Exit ticket, quiz, rubriche e strumenti di monitoraggio',
    description:
      'Un sistema completo per verificare rapidamente che cosa gli studenti hanno compreso e quali concetti devono essere ripresi. Comprende verifiche diagnostiche, exit ticket, quiz da 5 e 10 minuti, attività di analisi degli errori, autovalutazioni, rubriche e griglie di monitoraggio.',
    pages: '60 pagine',
    value: '47 USD',
  },
  {
    badge: 'BONUS 4',
    icon: '📚',
    title: 'AULA DI CHIMICA VISIVA™',
    subtitle: 'Poster, tavole di consultazione e carte visive',
    description:
      'Una biblioteca visuale da proiettare, stampare, esporre o distribuire agli studenti. Comprende materiali dedicati alla materia, alla struttura atomica, alla tavola periodica, ai legami, alla nomenclatura, alla stechiometria, al pH, alla chimica organica, alle biomolecole e alla sicurezza.',
    pages: '48 pagine',
    value: '47 USD',
  },
];

export interface Testimonial {
  text: string;
  name: string;
  city: string;
  role: string;
  initials: string;
}

/**
 * Segnaposto: nessuna testimonianza reale è ancora disponibile.
 * Sostituire ogni voce con testimonianze autentiche e verificabili prima della pubblicazione.
 */
export const testimonials: Testimonial[] = [
  {
    text: '[Inserire qui una testimonianza autentica di una docente che descriva il tempo risparmiato nella preparazione delle lezioni.]',
    name: '[Nome del docente]',
    city: '[Città]',
    role: '[Materia e livello di insegnamento]',
    initials: '—',
  },
  {
    text: '[Inserire qui una testimonianza autentica su come i materiali visuali hanno aiutato a spiegare un argomento astratto.]',
    name: '[Nome del docente]',
    city: '[Città]',
    role: '[Materia e livello di insegnamento]',
    initials: '—',
  },
  {
    text: '[Inserire qui una testimonianza autentica sull’utilizzo delle verifiche A/B e delle soluzioni per il docente.]',
    name: '[Nome del docente]',
    city: '[Città]',
    role: '[Materia e livello di insegnamento]',
    initials: '—',
  },
  {
    text: '[Inserire qui una testimonianza autentica sull’organizzazione dei materiali per argomento durante l’anno scolastico.]',
    name: '[Nome del docente]',
    city: '[Città]',
    role: '[Materia e livello di insegnamento]',
    initials: '—',
  },
  {
    text: '[Inserire qui una testimonianza autentica sull’utilizzo dei laboratori e delle attività operative in classe.]',
    name: '[Nome del docente]',
    city: '[Città]',
    role: '[Materia e livello di insegnamento]',
    initials: '—',
  },
  {
    text: '[Inserire qui una testimonianza autentica sul coinvolgimento degli studenti con i giochi didattici.]',
    name: '[Nome del docente]',
    city: '[Città]',
    role: '[Materia e livello di insegnamento]',
    initials: '—',
  },
  {
    text: '[Inserire qui una testimonianza autentica sull’utilizzo dei poster e delle tavole di consultazione in aula.]',
    name: '[Nome del docente]',
    city: '[Città]',
    role: '[Materia e livello di insegnamento]',
    initials: '—',
  },
];

export interface Highlight {
  title: string;
  detail: string;
}

/**
 * Promemoria informativi mostrati nel riquadro flottante.
 * Contengono solo caratteristiche verificabili del prodotto, nessun dato di acquisto.
 */
export const highlights: Highlight[] = [
  {
    title: 'Accesso digitale immediato',
    detail: 'Ricevi i materiali via e-mail subito dopo l’acquisto.',
  },
  {
    title: 'Pagamento unico',
    detail: 'Nessun abbonamento mensile e nessun rinnovo automatico.',
  },
  {
    title: '504 pagine pronte da stampare',
    detail: '5 volumi completi e 4 bonus professionali.',
  },
  {
    title: 'Materiali interamente in italiano',
    detail: 'Pensati per la scuola secondaria di secondo grado.',
  },
  {
    title: 'Soluzioni per il docente incluse',
    detail: 'Verifiche A/B con relative correzioni.',
  },
  {
    title: 'Garanzia di rimborso di 7 giorni',
    detail: 'Esplora i materiali con tranquillità.',
  },
];

export interface Faq {
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    question: 'Che cosa riceverò esattamente?',
    answer:
      'Riceverai l’accesso digitale ai cinque volumi di CHIMICA VISIVA™ e ai quattro bonus professionali: 504 pagine complessive in PDF, con schede teoriche visuali, attività, laboratori, verifiche A/B, soluzioni per il docente, giochi, progetti scientifici, strumenti di valutazione e materiali da esporre in aula.',
  },
  {
    question: 'Si tratta di un prodotto fisico?',
    answer:
      'No. CHIMICA VISIVA™ è un prodotto interamente digitale: non verrà spedito alcun materiale fisico.',
  },
  {
    question: 'Come riceverò i materiali?',
    answer:
      'Al termine dell’acquisto riceverai l’accesso all’indirizzo e-mail indicato durante il pagamento. Ti consigliamo di controllare anche le cartelle spam e promozioni.',
  },
  {
    question: 'Devo pagare un abbonamento mensile?',
    answer:
      'No. Si tratta di un pagamento unico. Non esistono abbonamenti mensili né rinnovi automatici.',
  },
  {
    question: 'Per quanto tempo potrò utilizzare i materiali?',
    answer:
      'L’accesso ai materiali digitali inclusi nell’offerta non ha scadenza: potrai utilizzarli anno dopo anno.',
  },
  {
    question: 'Sono incluse le soluzioni?',
    answer:
      'Sì. Le soluzioni per il docente sono incluse per le attività e per le verifiche A/B corrispondenti.',
  },
  {
    question: 'Per quali classi è stato progettato?',
    answer:
      'I materiali sono pensati principalmente per la chimica nella scuola secondaria di secondo grado e possono essere adattati a livelli e programmi diversi.',
  },
  {
    question: 'Posso utilizzare i materiali con i miei studenti?',
    answer:
      'Sì. La licenza è individuale e prevede l’utilizzo nelle classi del docente che effettua l’acquisto. La redistribuzione, la condivisione integrale e la rivendita dei materiali non sono consentite.',
  },
  {
    question: 'I materiali sono interamente in italiano?',
    answer: 'Sì. Testi, attività, verifiche e soluzioni sono interamente in italiano.',
  },
  {
    question: 'Posso utilizzare solo alcune pagine?',
    answer:
      'Certamente. Ogni volume è organizzato per argomento: puoi stampare o proiettare solo le pagine utili alla lezione del giorno.',
  },
  {
    question: 'È necessario installare un’applicazione?',
    answer:
      'No. I file sono in formato PDF e si aprono su qualsiasi computer, tablet o telefono, senza applicazioni obbligatorie.',
  },
  {
    question: 'Posso richiedere un rimborso?',
    answer:
      'Sì. Puoi contattarci entro sette giorni dall’acquisto e richiedere il rimborso secondo le condizioni indicate nella nostra politica di rimborso.',
  },
];
